module.exports = __webpack_public_path__ + "static/media/viewDetailsIcon.4fe21013.svg";